import { useTranslation } from 'next-i18next';
import { SyntheticEvent, useState } from 'react';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { A, Button } from '@bridebook/ui';
import { IconPhone } from '@bridebook/ui/src/icons';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';

export interface IShowPhoneProps {
  supplier: ISupplier | undefined;
  isMobile: boolean;
  isCordova: boolean;
  useSignupLink: boolean;
  onClick?: () => void;
}

const ShowPhone = ({ supplier, isCordova, isMobile, useSignupLink, onClick }: IShowPhoneProps) => {
  const [phoneVisible, setPhoneVisible] = useState(false);
  const { t } = useTranslation('supplier');

  const onClickPhone = (e: SyntheticEvent<any>): void => {
    if (!isMobile) {
      e.preventDefault();
      setPhoneVisible(true);
    }
    if (!phoneVisible || isMobile) {
      onClick?.();
    }
  };

  const phone = supplier?.contacts?.phone;

  const button = (
    <Button
      theme="ghost"
      color="space"
      icon={<IconPhone />}
      text={phoneVisible ? phone : t('locationContact.phone')}
    />
  );

  return useSignupLink ? (
    <SignupLink clickedLocation="supplierProfile" clickedSection="contactDetails" cta="phone">
      {button}
    </SignupLink>
  ) : (
    <A
      href={`tel:${phone}`}
      onClick={onClickPhone}
      data-link-type="phone"
      target={isCordova ? '_system' : undefined}>
      {button}
    </A>
  );
};

export default ShowPhone;
